/**
 * Doğum tarihinden yaş hesapla
 * @param {string} dateOfBirth - "YYYY-MM-DD" formatında doğum tarihi
 * @returns {number} - Yaş
 */
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return null;
  
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // Doğum günü henüz gelmemişse yaşı 1 azalt
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

/**
 * Yaş doğrulama (18 yaş kontrolü vb.)
 * @param {string} dateOfBirth - "YYYY-MM-DD" formatında doğum tarihi
 * @param {number} minAge - Minimum yaş (varsayılan 18)
 * @returns {boolean}
 */
export const isAgeValid = (dateOfBirth, minAge = 18) => {
  const age = calculateAge(dateOfBirth);
  return age !== null && age >= minAge;
};

/**
 * Tarih formatla (Türkçe)
 * @param {string} date - ISO tarih string'i
 * @returns {string}
 */
export const formatDateTurkish = (date) => {
  if (!date) return '';
  
  try {
    return new Date(date).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return date;
  }
};

/**
 * Input için tarih formatı (YYYY-MM-DD)
 * Firestore Timestamp veya ISO string kabul eder.
 * @param {string|object} isoDate - ISO tarih string'i veya Firestore Timestamp (.toDate metodu olan)
 * @returns {string}
 */
export const formatDateForInput = (isoDate) => {
  if (isoDate == null || isoDate === '') return '';
  
  try {
    let date;
    if (typeof isoDate?.toDate === 'function') {
      date = isoDate.toDate();
    } else {
      date = new Date(isoDate);
    }
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch {
    return '';
  }
};

/**
 * Maksimum doğum tarihi (18 yaş için)
 * @returns {string} - "YYYY-MM-DD" formatında
 */
export const getMaxBirthDate = (minAge = 18) => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - minAge);
  return formatDateForInput(today.toISOString());
};

/**
 * Minimum doğum tarihi (100 yaş için)
 * @returns {string} - "YYYY-MM-DD" formatında
 */
export const getMinBirthDate = (maxAge = 100) => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - maxAge);
  return formatDateForInput(today.toISOString());
};

